<!-- Distillation Funnel -->
<div class="distillation-funnel-container container-fluid py-4">
  <div class="d-flex align-items-center mb-4">
    <h2 class="mb-0 me-2">Event Distillation Pipeline</h2>
    <kendo-svg-icon
      [icon]="infoCircleIcon"
      size="small"
      class="info-icon"
      kendoTooltip
      title="Shows the flow of security events through the CyFlare pipeline. Ingested shows all events consumed by SOAR and multiple identical events are consolidated. Escalations are the number of tickets created from the consolidated cases. Incidents are the number of Critical and High priority escalations."
    ></kendo-svg-icon>
  </div>

  <div class="distillation-funnel row g-3 mb-5">
    <!-- Total Ingested Events -->
    <div
      class="funnel-stage raw-events col position-relative"
      (click)="onContextMenuSelect({ text: 'View Alert Data' }, 'raw_events')"
    >
      <div class="stage-content card h-100">
        <div class="tile hud-tile">
          <div class="card-body text-center">
            @if (isLoading()) {
              <kendo-skeleton
                shape="text"
                animation="wave"
                width="48px"
                height="48px"
                class="mx-auto mb-2"
              ></kendo-skeleton>
              <kendo-skeleton
                shape="text"
                animation="wave"
                width="150px"
                height="16px"
                class="mx-auto mb-2"
              ></kendo-skeleton>
              <kendo-skeleton
                shape="text"
                animation="wave"
                width="80px"
                height="32px"
                class="mx-auto mb-2"
              ></kendo-skeleton>
              <kendo-skeleton
                shape="text"
                animation="wave"
                width="120px"
                height="14px"
                class="mx-auto"
              ></kendo-skeleton>
            } @else {
              <div class="stage-icon mb-2">
                <kendo-svg-icon
                  [icon]="dataIcon"
                  size="large"
                ></kendo-svg-icon>
              </div>
              <div class="stage-metrics">
                <div class="stage-title mb-2">Total Ingested Events</div>
                <div class="stage-value h2 mb-2">
                  {{
                    AlertStatSummary().total_ingest_current !== null
                      ? AlertStatSummary().total_ingest_current
                      : (0 | number)
                  }}
                </div>
                <div
                  class="stage-comparison small"
                  [class.text-success]="
                    (AlertStatSummary().total_ingest_current !== null ? AlertStatSummary().total_ingest_current : 0) >
                    (AlertStatSummary().total_ingest_previous !== null ? AlertStatSummary().total_ingest_previous : 0)
                  "
                  [class.text-danger]="
                    (AlertStatSummary().total_ingest_current !== null ? AlertStatSummary().total_ingest_current : 0) <
                    (AlertStatSummary().total_ingest_previous !== null ? AlertStatSummary().total_ingest_previous : 0)
                  "
                >
                  @if (
                    (AlertStatSummary().total_ingest_current !== null ? AlertStatSummary().total_ingest_current : 0) >
                    (AlertStatSummary().total_ingest_previous !== null ? AlertStatSummary().total_ingest_previous : 0)
                  ) {
                    <span>↑</span>
                  }
                  @if (
                    (AlertStatSummary().total_ingest_current !== null ? AlertStatSummary().total_ingest_current : 0) <
                    (AlertStatSummary().total_ingest_previous !== null ? AlertStatSummary().total_ingest_previous : 0)
                  ) {
                    <span>↓</span>
                  }
                  {{
                    AlertStatSummary().total_ingest_pct_change !== null
                      ? AlertStatSummary().total_ingest_pct_change
                      : (0 | number: '1.1-1')
                  }}% vs previous
                </div>
              </div>
            }
          </div>
        </div>
      </div>
      <div class="funnel-connector">
        <div class="connector-arrow"></div>
      </div>
    </div>

    <!-- Consolidated Cases -->
    <div
      class="funnel-stage detections col position-relative"
      (click)="onContextMenuSelect({ text: 'View Alert Data' }, 'detections')"
    >
      <div class="stage-content card h-100">
        <div class="tile hud-tile">
          <div class="card-body text-center">
            @if (isLoading()) {
              <kendo-skeleton
                shape="text"
                animation="wave"
                width="48px"
                height="48px"
                class="mx-auto mb-2"
              ></kendo-skeleton>
              <kendo-skeleton
                shape="text"
                animation="wave"
                width="150px"
                height="16px"
                class="mx-auto mb-2"
              ></kendo-skeleton>
              <kendo-skeleton
                shape="text"
                animation="wave"
                width="80px"
                height="32px"
                class="mx-auto mb-2"
              ></kendo-skeleton>
              <kendo-skeleton
                shape="text"
                animation="wave"
                width="120px"
                height="14px"
                class="mx-auto"
              ></kendo-skeleton>
            } @else {
              <div class="stage-icon mb-2">
                <img
                  src="assets/icons/detection-icon.png"
                  alt="Detection Icon"
                  width="24"
                  height="24"
                />
              </div>
              <div class="stage-metrics">
                <div class="stage-title mb-2">Consolidated Cases</div>
                <div class="stage-value h2 mb-2">
                  {{
                    AlertStatSummary().unique_case_count_current !== null
                      ? AlertStatSummary().unique_case_count_current
                      : (0 | number)
                  }}
                </div>
                <div
                  class="stage-comparison small"
                  [class.text-success]="
                    (AlertStatSummary().unique_case_count_current !== null
                      ? AlertStatSummary().unique_case_count_current
                      : 0) >
                    (AlertStatSummary().unique_case_count_previous !== null
                      ? AlertStatSummary().unique_case_count_previous
                      : 0)
                  "
                  [class.text-danger]="
                    (AlertStatSummary().unique_case_count_current !== null
                      ? AlertStatSummary().unique_case_count_current
                      : 0) <
                    (AlertStatSummary().unique_case_count_previous !== null
                      ? AlertStatSummary().unique_case_count_previous
                      : 0)
                  "
                >
                  @if (
                    (AlertStatSummary().unique_case_count_current !== null
                      ? AlertStatSummary().unique_case_count_current
                      : 0) >
                    (AlertStatSummary().unique_case_count_previous !== null
                      ? AlertStatSummary().unique_case_count_previous
                      : 0)
                  ) {
                    <span>↑</span>
                  } @else if (
                    (AlertStatSummary().unique_case_count_current !== null
                      ? AlertStatSummary().unique_case_count_current
                      : 0) <
                    (AlertStatSummary().unique_case_count_previous !== null
                      ? AlertStatSummary().unique_case_count_previous
                      : 0)
                  ) {
                    <span>↓</span>
                  }
                  {{
                    AlertStatSummary().unique_case_count_pct_change !== null
                      ? AlertStatSummary().unique_case_count_pct_change
                      : (0 | number: '1.1-1')
                  }}% vs previous
                </div>
              </div>
            }
          </div>
        </div>
      </div>
      <div class="funnel-connector">
        <div class="connector-arrow"></div>
      </div>
    </div>

    <!-- Escalations -->
    <div
      class="funnel-stage escalations col position-relative"
      (click)="onContextMenuSelect({ text: 'View Ticket Data' }, 'escalations')"
    >
      <div class="stage-content card h-100">
        <div class="tile hud-tile">
          <div class="card-body text-center">
            @if (isLoading()) {
              <kendo-skeleton
                shape="text"
                animation="wave"
                width="48px"
                height="48px"
                class="mx-auto mb-2"
              ></kendo-skeleton>
              <kendo-skeleton
                shape="text"
                animation="wave"
                width="150px"
                height="16px"
                class="mx-auto mb-2"
              ></kendo-skeleton>
              <kendo-skeleton
                shape="text"
                animation="wave"
                width="80px"
                height="32px"
                class="mx-auto mb-2"
              ></kendo-skeleton>
              <kendo-skeleton
                shape="text"
                animation="wave"
                width="120px"
                height="14px"
                class="mx-auto"
              ></kendo-skeleton>
            } @else {
              <div class="stage-icon mb-2">
                <kendo-svg-icon
                  [icon]="infoSolidIcon"
                  size="large"
                ></kendo-svg-icon>
              </div>
              <div class="stage-metrics">
                <div class="stage-title mb-2">Escalations</div>
                <div class="stage-value h2 mb-2">
                  {{ ticketTrends().total_count_current !== null ? ticketTrends().total_count_current : (0 | number) }}
                </div>
                <div
                  class="stage-comparison small"
                  [class.text-success]="
                    (ticketTrends().total_count_current !== null ? ticketTrends().total_count_current : 0) <
                    (ticketTrends().total_count_previous !== null ? ticketTrends().total_count_previous : 0)
                  "
                  [class.text-danger]="
                    (ticketTrends().total_count_current !== null ? ticketTrends().total_count_current : 0) >
                    (ticketTrends().total_count_previous !== null ? ticketTrends().total_count_previous : 0)
                  "
                >
                  @if (
                    (ticketTrends().total_count_current !== null ? ticketTrends().total_count_current : 0) <
                    (ticketTrends().total_count_previous !== null ? ticketTrends().total_count_previous : 0)
                  ) {
                    <span>↓</span>
                  }
                  @if (
                    (ticketTrends().total_count_current !== null ? ticketTrends().total_count_current : 0) >
                    (ticketTrends().total_count_previous !== null ? ticketTrends().total_count_previous : 0)
                  ) {
                    <span>↑</span>
                  }
                  {{
                    ticketTrends().total_count_pct_change !== null
                      ? ticketTrends().total_count_pct_change
                      : (0 | number: '1.1-1')
                  }}% vs previous
                </div>
              </div>
            }
          </div>
        </div>
      </div>
      <div class="funnel-connector">
        <div class="connector-arrow"></div>
      </div>
    </div>

    <!-- Incidents -->
    <div
      class="funnel-stage incidents col"
      (click)="onContextMenuSelect({ text: 'View Ticket Data' }, 'incidents')"
    >
      <div class="stage-content card h-100">
        <div class="tile hud-tile">
          <div class="card-body text-center">
            @if (isLoading()) {
              <kendo-skeleton
                shape="text"
                animation="wave"
                width="48px"
                height="48px"
                class="mx-auto mb-2"
              ></kendo-skeleton>
              <kendo-skeleton
                shape="text"
                animation="wave"
                width="150px"
                height="16px"
                class="mx-auto mb-2"
              ></kendo-skeleton>
              <kendo-skeleton
                shape="text"
                animation="wave"
                width="80px"
                height="32px"
                class="mx-auto mb-2"
              ></kendo-skeleton>
              <kendo-skeleton
                shape="text"
                animation="wave"
                width="120px"
                height="14px"
                class="mx-auto"
              ></kendo-skeleton>
            } @else {
              <div class="stage-icon mb-2">
                <kendo-svg-icon
                  [icon]="warningTriangleIcon"
                  size="large"
                ></kendo-svg-icon>
              </div>
              <div class="stage-metrics">
                <div class="stage-title mb-2">Incidents</div>
                <div class="stage-value h2 mb-2">
                  {{
                    ticketTrends().total_tp_count_current !== null
                      ? ticketTrends().total_tp_count_current
                      : (0 | number)
                  }}
                </div>
                <div
                  class="stage-comparison small"
                  [class.text-success]="
                    (ticketTrends().total_tp_count_current !== null ? ticketTrends().total_tp_count_current : 0) <
                    (ticketTrends().total_tp_count_previous !== null ? ticketTrends().total_tp_count_previous : 0)
                  "
                  [class.text-danger]="
                    (ticketTrends().total_tp_count_current !== null ? ticketTrends().total_tp_count_current : 0) >
                    (ticketTrends().total_tp_count_previous !== null ? ticketTrends().total_tp_count_previous : 0)
                  "
                >
                  @if (
                    (ticketTrends().total_tp_count_current !== null ? ticketTrends().total_tp_count_current : 0) <
                    (ticketTrends().total_tp_count_previous !== null ? ticketTrends().total_tp_count_previous : 0)
                  ) {
                    <span>↓</span>
                  }
                  @if (
                    (ticketTrends().total_tp_count_current !== null ? ticketTrends().total_tp_count_current : 0) >
                    (ticketTrends().total_tp_count_previous !== null ? ticketTrends().total_tp_count_previous : 0)
                  ) {
                    <span>↑</span>
                  }
                  {{
                    ticketTrends().total_tp_count_pct_change !== null
                      ? ticketTrends().total_tp_count_pct_change
                      : (0 | number: '1.1-1')
                  }}% vs previous
                </div>
              </div>
            }
          </div>
        </div>
      </div>
    </div>
  </div>

  <div class="funnel-insight mt-2">
    @if (isLoading()) {
      <div class="alert alert-info d-flex align-items-center py-2">
        <kendo-skeleton
          shape="text"
          animation="wave"
          width="100%"
          height="20px"
        ></kendo-skeleton>
      </div>
    } @else {
      <div class="insight-note alert alert-info d-flex align-items-center py-2">
        <i class="fas fa-lightbulb me-2"></i>
        <span>
          Our service reduced
          {{
            AlertStatSummary().total_ingest_current !== null ? AlertStatSummary().total_ingest_current : (0 | number)
          }}
          potential threats to just
          {{ ticketTrends().total_tp_count_current !== null ? ticketTrends().total_tp_count_current : (0 | number) }}
          critical incidents, demonstrating a
          {{
            Math.min(
              99.99,
              (((AlertStatSummary().total_ingest_current !== null ? AlertStatSummary().total_ingest_current : 0) -
                (ticketTrends().total_tp_count_current !== null ? ticketTrends().total_tp_count_current : 0)) /
                (AlertStatSummary().total_ingest_current !== null ? AlertStatSummary().total_ingest_current : 1)) *
                100
            ) | number: '1.2-2'
          }}% reduction in security noise.
        </span>
      </div>
    }
  </div>

  <!-- Reusable Alert Data Dialog -->
  @if (alertDialogConfig()) {
    <app-alert-data-dialog
      [config]="alertDialogConfig()!"
      [visible]="showAlertDialog()"
      (close)="onAlertDialogClose()"
      (exportCsv)="triggerExport()"
    />
  }

  <!-- Reusable Ticket Data Dialog -->
  @if (ticketDialogConfig()) {
    <app-ticket-data-dialog
      [config]="ticketDialogConfig()!"
      [visible]="showTicketDialog()"
      (close)="onTicketDialogClose()"
      (exportCsv)="triggerExport()"
    />
  }
</div>
